"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, type ReactNode } from "react";
import { usePathname } from "next/navigation";
import { I18nextProvider } from "react-i18next";
import i18n from "@/shared/config/i18n/client";
import { LANGUAGE_STORAGE_KEY, resolveLanguage, type AppLanguage } from "@/shared/config/i18n/config";
import { enResources } from "@/shared/config/i18n/locales/en";
import { ruResources } from "@/shared/config/i18n/locales/ru";
import { loadLanguageBundle } from "@/shared/config/i18n/resources";
const ROUTE_LANGUAGE_PREFIXES: Partial<Record<AppLanguage, string>> = {
  ru: "/ru",
  en: "/en"
};
const ROUTE_LANGUAGE_RESOURCES = {
  ru: ruResources,
  en: enResources
} as const;
function resolveRouteLanguage(pathname: string): AppLanguage | null {
  for (const [language, prefix] of Object.entries(ROUTE_LANGUAGE_PREFIXES)) {
    if (pathname === prefix || pathname.startsWith(`${prefix}/`)) {
      return language as AppLanguage;
    }
  }
  return null;
}
function prepareRouteLanguage(language: keyof typeof ROUTE_LANGUAGE_RESOURCES) {
  if (!i18n.exists("landing.hero.title1", {
    lng: language
  })) {
    i18n.addResourceBundle(language, "translation", ROUTE_LANGUAGE_RESOURCES[language].translation, true, true);
  }
  if (i18n.resolvedLanguage !== language) {
    void i18n.changeLanguage(language);
  }
}
export function I18nProvider(t0) {
  const $ = _c(9);
  const {
    children
  } = t0;
  const pathname = usePathname();
  let routeLanguage;
  if ($[0] !== pathname) {
    routeLanguage = resolveRouteLanguage(pathname);
    if (routeLanguage === "ru" || routeLanguage === "en") {
      prepareRouteLanguage(routeLanguage);
    }
    $[0] = pathname;
    $[1] = routeLanguage;
  } else {
    routeLanguage = $[1];
  }
  let t1;
  if ($[2] !== routeLanguage) {
    t1 = () => {
      const storedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
      const nextLanguage = routeLanguage ?? resolveLanguage(storedLanguage ?? navigator.language);
      document.documentElement.lang = nextLanguage;
      if (i18n.resolvedLanguage !== nextLanguage) {
        loadLanguageBundle(nextLanguage).then(bundle => {
          if (bundle) {
            i18n.addResourceBundle(nextLanguage, "translation", bundle.translation, true, true);
          }
          i18n.changeLanguage(nextLanguage);
        });
      }
    };
    $[2] = routeLanguage;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== pathname || $[5] !== routeLanguage) {
    t2 = [pathname, routeLanguage];
    $[4] = pathname;
    $[5] = routeLanguage;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] !== children) {
    t3 = <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
    $[7] = children;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}